export { default as PageNotFound } from './page-not-found.svg'
export { default as Cityscape } from './33m2-cityscape.svg'
export { default as HighRentalIncome } from './high-rental-income.svg'
export { default as FastVacancyResolution } from './fast-vacancy-resolution.svg'
export { default as ConvenientManagement } from './convenient-management.svg'
export { default as SafeRental } from './safe-rental.svg'
export { default as ReasonableContract } from './reasonable-contract.svg'
export { default as AppStore } from './app-store.svg'
export { default as GooglePlay } from './google-play.svg'
